<template>
  <Layout>
    <!-- <PageHeader v-if="title" :title="title" :items="items" /> -->

    <Loader :loading="loadingExport" no-axios>
      <div class="">
        <div v-if="stats.length" class="row">
          <div class="title">{{ lodash.upperCase(title) }}</div>
          <div v-for="stat of stats" :key="stat.icon" :class="stat.wrapperClass">
            <Stat v-bind="stat"/>
          </div>
        </div>
        <div v-if="!lodash.isEmpty(filterColumns) && stats.length">
          <model-filter
              v-model="filter"
              :columns="filterColumns"
              :filterHandler="filterHandler"
              :modelVariable="modelVariable"
          />
        </div>
      </div>
      <div class="title">{{ lodash.upperCase($t("List")) }} {{ lodash.upperCase(title) }}</div>
      <div class="row">
        <model-index
            ref="table"
            :actions="actions"
            :action-buttons="actionButtons"
            :busy.sync="busy"
            :columns="columns"
            :filter-params.sync="filterParams"
            :from="from"
            :loading="loading"
            :models-paginated="modelsPaginated"
            :page.sync="page"
            :per-page.sync="perPage"
            :search.sync="search"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :title="undefined"
            :total="totalFiltered"
            class="col-12"
            v-bind="$props"
            @create-click="handleCreate"
            @export-click="handleExport"
            @show-click="handleShow"
            @edit-click="handleEdit"
            @delete-click="handleDelete"
        >
        </model-index>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelFilter from "@/router/views/purchase_orders/filter";
import ModelIndex from "../models/index-v3";
import icons from "@/assets/icons";
import DownPaymentFormExport from "@/components/modals/down-payment-form-export";
import JalaAppIcon from "@/assets/icons/JalaApp.svg";
import JalaHarvestIcon from "@/assets/icons/JalaHarvest.svg";
import JalaProIcon from "@/assets/icons/JalaPro.svg";
import StatusWidget from "@/components/widgets/statuses/status";
import StatusTonWidget from "@/components/widgets/statuses/status-with-ton";
import StatusDateWidget from "@/components/widgets/statuses/status-with-date";
import Swal from "sweetalert2";
import StatusBadge from "@/components/badges/status-badge.vue";
import {hasAllowedAction as hasAllowedActionHelper} from "@/helpers/ui/allowedActions";

/* eslint-disable vue/no-unused-components */
export default {
  extends: ModelIndex,
  components: {
    StatusBadge,
    ModelFilter,
    DownPaymentFormExport,
    icons,
    JalaAppIcon,
    JalaHarvestIcon,
    JalaProIcon,
    StatusWidget,
    StatusTonWidget,
    StatusDateWidget
  },
  page: {
    title: "Purchase Orders"
  },
  props: {
    // cardTitle: { default() { return this.lodash.startCase(this.$t('menuitems.purchase_orders.text')) } },
    resourceRoute: {default: "purchase_orders"},
    modelVariable: {default: "purchase_order"},
    denyCreate: {
      type: Boolean,
      default() {
        return !this.$auth.hasPermissionTo('purchase_orders.create');
      }
    },
    modals: {
      default() {
        return ["down-payment-form-export"];
      }
    },

    tableProps: {
      default() {
        return {
          "tbody-tr-class": function (item, type) {
            if (!item || !type) return;
            let classes = "";
            if (item.highlighted) {
              classes += " highlighted-row";
            }
            if (item.highlight_separator) {
              classes += " highlighted-separator";
            }
            return classes;
          }
        };
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("purchase_orders.plural")),
      items: [
        {
          text: this.lodash.startCase(this.$t("purchase_orders.singular")),
          href: "/purchase_orders",
          active: true
        }
      ],
      sortBy:
          (this.$route.query.sort &&
              this.$route.query.sort
                  .split("|")
                  .shift()
                  .split(",")
                  .shift()) ||
          "id",
      sortDesc:
          (this.$route.query.sort &&
              this.$route.query.sort
                  .split("|")
                  .shift()
                  .split(",")
                  .pop() === "desc") ||
          true,
      filterColumns: {
        "ticket.customer_type": {
          type: String,
          label: this.lodash.upperFirst(this.$t("purchase_orders.customer_type")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("purchase_orders.customer_type")),
          operator: "in",
          input_component: "customer-type-select"
        },
        id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("purchase_orders.purchase_order_id")),
          params: {
            sort: "id,desc",
            select: "id",
            minimal: 1
          },
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("purchase_orders.purchase_order_id")),
          operator: "in",
          input_component: "purchase-order-multiselect-ajax",
          searchKey: "id"
        },
        product_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("products.singular")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("products.singular")),
          operator: "in",
          input_component: "product-service-multiselect-ajax"
        },
        ordered_at__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("purchase_orders.ordered_at")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("purchase_orders.ordered_at")),
          operator: "between",
          input_component: "datepicker-range"
        },
        customer_id__in: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("purchase_orders.partner")),
          placeholder: "Pilih " + this.lodash.upperFirst(this.$t("purchase_orders.partner")),
          operator: "in",
          input_component: "supplier-multiselect-ajax"
        },
        odoo_purchase_order_state__in: {
          type: String,
          label: this.lodash.startCase(this.$t("purchase_orders.odoo_purchase_orders.state")),
          placeholder: "Pilih " + this.lodash.startCase(this.$t("purchase_orders.odoo_purchase_orders.state")),
          input_component: "odoo-purchase-order-state-select"
        },
        odoo_purchase_order_invoice_status__in: {
          type: String,
          label: this.lodash.startCase(this.$t("purchase_orders.odoo_purchase_orders.invoice_status")),
          placeholder: "Pilih " + this.lodash.startCase(this.$t("purchase_orders.odoo_purchase_orders.invoice_status")),
          input_component: "odoo-purchase-order-invoice-status-select"
        }
      },
      model: this.modelVariable,
    };
  },
  computed: {
    actions() {
      return [
        {
          component: {
            methods: {
              failedAlert() {
                return Swal.fire({
                  title: this.$t("Failed") + "!",
                  text: 'Failed to sync odoo purchase order updated today ',
                  type: "danger",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              },
              onClickSyncUpdatedToday() {
                return this.$axios.post('/v1/purchase_orders/updated_today/sync_from_odoo')
                    .then(() => {
                      return this.syncUpdatedTodayQueueInProgressAlert();
                    })
                    .catch(e => this.failedAlert(e))
              },
              syncUpdatedTodayQueueInProgressAlert() {
                return Swal.fire({
                  title: `Sync Odoo Purchase Order in Progress`,
                  type: "primary",
                  confirmButtonClass: "btn btn-success",
                  confirmButtonText: this.$t("ok"),
                  buttonsStyling: false
                }).then((res) => {
                  if (res.isConfirmed) {
                    this.$router.go(0)
                  }
                });
              },
            },
            template: `
                <b-button
                  variant="primary"
                  size="lg"
                  class="me-2"
                  @click="onClickSyncUpdatedToday"
                  style="font-size: 14px"
                >
                  {{ lodash.upperFirst($t('purchase_orders.odoo_purchase_orders.sync_updated_today_button_text')) }}
                </b-button>
              `
          },
          _hidden: !this.$auth.hasPermissionTo('purchase_orders.sync')
        },
      ].filter(action => !action._hidden);
    },
    actionButtons() {
      return [
        {
          key: 'sync-to-odoo',
          action: (v) => this.handleSyncToOdoo(v),
          label: this.lodash.upperFirst(this.$t('purchase_orders.odoo_purchase_orders.sync_to_odoo')),
          disable: (v) => {
            let isRfqAlreadyCreated = !!v.odoo_purchase_order_id
            if (isRfqAlreadyCreated) {
              return true;
            }

            let isOldData = !v.odoo_purchase_order
            let vendorHasPartnerId = null
            if (isOldData) {
              vendorHasPartnerId = !!v.customer?.odoo_partner_id
              return !vendorHasPartnerId
            }
            vendorHasPartnerId = v.odoo_purchase_order?.vendor_selection === 'farmer' ?
                !!v.farmer?.odoo_partner_id : !!v.customer?.odoo_partner_id

            return !vendorHasPartnerId
          },
          hide: () => {
            return !this.$auth.hasPermissionTo('purchase_orders.sync');
          }
        },
      ]
    },
    columns() {
      return {
        ["purchase_order"]: [
          // { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
          {
            key: "ticket_id",
            label: this.lodash.startCase(this.$t("tickets.ticket_id")),
            thStyle: {width: "100px"},
            sortable: true,
            component: {
              props: ["item"],
              computed: {
                customLabel() {
                  return `${this.item.ticket_id}: ${this.$t(
                      `tickets.customer_types.${this.item.ticket.customer_type}`
                  )}`;
                }
              },
              template: '<router-link :to="`/tickets/${(item || {}).ticket_id}`">{{ customLabel }}</router-link>'
            }
          },
          {
            key: "id",
            label: this.lodash.startCase(this.$t("tickets.purchase_order_id")),
            thStyle: {minWidth: "120px"},
            sortable: true,
            component: {
              props: ["item"],
              computed: {
                formatedId() {
                  return `${this.item.sub_product_name} - ${this.item.id}`;
                },
                formatedOrderedAt() {
                  return this.$moment.utc(this.item.ordered_at).local().format("DD MMM YYYY")
                }
              },
              template: `<div><span v-html="formatedId"></span><br><span style="color: #475569; font: 400 10px/14px Lato, sans-serif">{{ formatedOrderedAt }}</span></div>`
            }
          },
          {
            key: "customer.name",
            label: this.lodash.startCase(this.$t("purchase_orders.partner")),
            thStyle: {minWidth: "150px"},
            sortable: true,
            component: {
              props: ["item"],
              template:
                  '<router-link :to="`/customers/${(item.customer || {}).id}`">{{ lodash.get(item, "customer.name")}}</router-link>'
            }
          },
          {
            key: "farmer.name",
            label: this.lodash.startCase(this.$t("purchase_orders.farmer")),
            thStyle: {minWidth: "150px"},
            sortable: true,
            tdClass: "separator-badge",
            component: {
              props: ["item"],
              data() {
                return {
                  icons,
                  JalaAppIcon,
                  JalaHarvestIcon,
                  JalaProIcon
                };
              },
              computed: {
                icon() {
                  if (!this.item.farmer) {
                    return false;
                  }
                  if (this.item.pro_cycle) {
                    return this.icons.JalaPro;
                  }
                  if (this.item.farm.use_jala_farm) {
                    return this.icons.JalaApp;
                  } else {
                    return this.icons.JalaHarvest;
                  }
                },
                tooltip() {
                  if (this.item.pro_cycle) {
                    return "Terdaftar dalam Siklus Pro";
                  } else if (this.item.farm?.use_jala_farm) {
                    return "Pengguna JALA Apps";
                  }
                  return "Mitra JALA Harvest";
                }
              },
              template: `
                <div v-if="item.farmer" class="d-flex align-items-center gap-2" v-b-tooltip.hover :title="tooltip">
                  <div class="d-flex align-items-center">
                    <img style="width: 16px; height: 16px" v-if="item.pro_cycle" :src="JalaProIcon"></img>
                    <img style="width: 16px; height: 16px" v-else-if="item.farm && item.farm.use_jala_farm"
                         :src="JalaAppIcon"></img>
                    <img style="width: 16px; height: 16px" v-else :src="JalaHarvestIcon"></img>
                  </div>
                  <div>
                    {{ lodash.get(item, "farmer.name") }}
                  </div>
                </div>
                <span v-else>-</span>
              `
            }
          },
          {
            key: "purchase_item_total_quantity",
            label: this.lodash.startCase(this.$t("purchase_orders.total_biomass")),
            sortable: true,
            thStyle: {minWidth: "200px"},
            tdClass: "text-end",
            // formatter: value => value >= 500 ? `${this.$numeral(value / 1000).format('0,0.[000]')} ${this.$t('units.ton')}` :
            //     `${this.$numeral(value).format('0,0.[000]')} ${this.$t('units.kg')}`,
            component: {
              props: ["item"],
              computed: {
                totalBiomass() {
                  if (this.item.type === "down_payment") {
                    return "-";
                  }
                  return this.item.purchase_item_total_quantity >= 500
                      ? `${this.$numeral(this.item.purchase_item_total_quantity / 1000).format("0,0.[00]")} ${this.$t(
                          "units.ton"
                      )}`
                      : `${this.$numeral(this.item.purchase_item_total_quantity).format("0,0.[00]")} ${this.$t(
                          "units.kg"
                      )}`;
                },
                untransported() {
                  if (this.item.type === "down_payment") {
                    return "-";
                  }
                  return this.item.purchase_item_total_available_quantity >= 500
                      ? `${this.$numeral(this.item.purchase_item_total_available_quantity / 1000).format(
                          "0,0.[00]"
                      )} ${this.$t("ton")}`
                      : `${this.$numeral(this.item.purchase_item_total_available_quantity).format("0,0.[00]")} ${this.$t(
                          "units.kg"
                      )}`;
                }
              },
              /*html*/
              template: `
                <div>
                  <div class="d-flex">
                    <div style="color:#6C7589">Belum diangkut:&nbsp;</div>
                    <div>{{ untransported }}</div>
                  </div>
                  <div class="d-flex">
                    <div style="color:#6C7589">Total:&nbsp;</div>
                    <div>{{ totalBiomass }}</div>
                  </div>
                </div>`
            }
          },
          {
            key: "total",
            label: this.lodash.startCase(this.$t("purchase_orders.total_price")),
            thStyle: {minWidth: "175px"},
            tdClass: "text-end",
            sortable: true,
            // formatter: value => this.$numeral(value).format('$ 0,0')
            component: {
              props: ["item"],
              computed: {
                totalPrice() {
                  let value = this.item.total;
                  if (this.item.type === "down_payment") {
                    value = this.item.down_payment;
                  }
                  return this.$numeral(value).format("$ 0,0.[00]");
                }
              },
              template: `
                <div>{{ totalPrice }}</div>`
            }
          },
          {
            key: 'odoo_purchase_order.state',
            label: this.lodash.startCase(this.$t("purchase_orders.odoo_purchase_orders.state")),
            component: {
              props: ["item"],
              computed: {
                translatedState() {
                  let state = this.item.odoo_purchase_order?.state
                  if (!state) {
                    return '-'
                  }
                  return this.$t(`purchase_orders.odoo_purchase_orders.states.${state}`)
                },
                badgeClass() {
                  let state = this.item.odoo_purchase_order?.state

                  if (!state) {
                    return {'badge': true, 'bg-light': true}
                  }

                  if (state === 'purchase') {
                    return {'status-badge': true, 'badge': true, 'bg-success': true}
                  }  else if (state === 'to approve') {
                    return {'badge': true, 'bg-warning': true}
                  }

                  return {'badge': true, 'bg-light': true}
                },
              },
              template:`
                <status-badge
                    v-if="translatedState != '-'"
                    entity="odoo_purchase_order"
                    type="status"
                    :status="item.odoo_purchase_order.state"
                ></status-badge>
                <span v-else>-</span>
              `
            },
          },
          {
            key: 'odoo_purchase_order.invoice_status',
            label: this.lodash.startCase(this.$t("purchase_orders.odoo_purchase_orders.invoice_status")),
            component: {
              props: ["item"],
              computed: {
                translatedInvoiceStatus() {
                  let invoiceStatus = this.item.odoo_purchase_order?.invoice_status
                  if (!invoiceStatus) {
                    return '-'
                  }
                  return this.$t(`purchase_orders.odoo_purchase_orders.invoice_statuses.${invoiceStatus}`)
                },
                badgeClass() {
                  let invoiceStatus = this.item.odoo_purchase_order?.invoice_status

                  if (!invoiceStatus) {
                    return {'badge': true, 'bg-light': true}
                  }

                  if (invoiceStatus === 'invoiced') {
                    return {'status-badge': true, 'badge': true, 'bg-success': true}
                  }  else if (invoiceStatus === 'to invoice') {
                    return {'badge': true, 'bg-warning': true}
                  }

                  return {'badge': true, 'bg-light': true}
                },
              },
              template:`
                <status-badge
                    v-if="translatedInvoiceStatus != '-'"
                    entity="odoo_purchase_order"
                    type="invoice_status"
                    :status="item.odoo_purchase_order.invoice_status"
                ></status-badge>
                <span v-else>-</span>
              `
            },
          },
          {
            key: "odoo_purchase_order.name",
            label: 'Nomor RFQ',
            thStyle: {minWidth: "175px"},
            style: {width: "175px"},
            formatter: value => value ?? '-',
            component: {
              props: ['item'],
              computed: {
                hasOdooPurchaseOrderId() {
                  return !!this.item.odoo_purchase_order_id
                },
                hasOdooPurchaseOrder() {
                  return !!this.item.odoo_purchase_order
                },
                isDownPaymentPurchaseOrder() {
                  return this.item.type === 'down_payment'
                },
                invoiceNumber() {
                  return this.item.odoo_purchase_order?.reference_number
                },
                vendorHasOdooPartnerId() {
                  return this.item.odoo_purchase_order?.vendor_selection === 'farmer' ?
                      !!this.item.farmer?.odoo_partner_id : !!this.item.customer?.odoo_partner_id
                },
              },
              template: `
                <div>
                  <template v-if="hasOdooPurchaseOrderId && !hasOdooPurchaseOrder">
                    <i id="rfq-warning" class="fa fa-exclamation-circle" style="color: #ffc107"></i>
                    <b-tooltip placement="top" target="rfq-warning">
                      Data Fase 1 sementara tidak bisa ubah
                    </b-tooltip>
                  </template>
                  <template v-else-if="isDownPaymentPurchaseOrder">-</template>
                  <template v-else-if="invoiceNumber">{{ invoiceNumber }}</template>
                  <template v-else-if="!vendorHasOdooPartnerId">
                    <i id="rfq-warning" class="fa fa-exclamation-circle" style="color: #ffc107"></i>
                    <b-tooltip placement="top" target="rfq-warning">
                      Mitra/Petambak belum terkoneksi dengan Vendor di Odoo
                    </b-tooltip>
                  </template>
                  <template v-else>-</template>
                </div>
              `
            },
          },
          {
            key: 'odoo_purchase_order.odoo_sync_status',
            label: this.lodash.upperFirst(this.$t('purchase_orders.odoo_purchase_orders.latest_odoo_sync_status')),
            thStyle: {minWidth: "150px"},
            style: {width: "150px"},
            component: {
              props: ['item'],
              computed: {
                message() {
                  let isDone = this.item.odoo_purchase_order.state === 'done'
                  let isInvoiced = this.item.odoo_purchase_order.invoice_status === 'invoiced'
                  if (isDone && isInvoiced) {
                    return this.$t('purchase_orders.odoo_purchase_orders.odoo_sync_statuses.finished')
                  }

                  return !this.item.odoo_purchase_order.odoo_sync_status ? this.$t('purchase_orders.odoo_purchase_orders.odoo_sync_statuses.not_yet_synced') :
                      this.$t(`purchase_orders.odoo_purchase_orders.odoo_sync_statuses.${this.item.odoo_purchase_order.odoo_sync_status}`)
                }
              },
              template: `
                <div>
                  <span>{{ lodash.upperFirst(message) }}</span>
                </div>
              `
            },
          },
          {key: "action", label: this.$t("Action"), class: "text-center", style: {width: "1%"}}
        ]
      };
    }
  },
  methods: {
    handleDelete(value) {
      if (value.type === 'hybrid') {
        return this.delete(value)
            .then(() => this.deleteSuccessAlert(this.getModelName(value)))
            .catch(error => {
              this.failedAlert(error);
              return null;
            });
      }
      return this.deleteConfirmAlert().then(result => {
        if (result.value) {
          this.delete(value)
              .then(() => this.$refs.table.$refs.table.refresh())
              .then(() => this.deleteSuccessAlert(this.getModelName(value)))
              .catch(error => {
                this.failedAlert(error);
                return null;
              });
        }
      });
    },
    onClickSyncUpdatedToday() {
      this.disableSyncButton = true
      return this.$axios.post('/v1/purchase_orders/updated_today/sync_from_odoo')
          .then(() => {
            return this.syncUpdatedTodayQueueInProgressAlert();
          })
          .catch(e => this.failedAlert(e))
          .finally(() => {
            this.disableSyncButton = false
          })
    },
    syncUpdatedTodayQueueInProgressAlert() {
      return Swal.fire({
        title: `Sync Odoo Purchase Order in Progress`,
        type: "primary",
        confirmButtonClass: "btn btn-success",
        confirmButtonText: this.$t("ok"),
        buttonsStyling: false
      }).then((res) => {
        if (res.isConfirmed) {
          this.$router.go(0)
        }
      });
    },
    getModelName(value) {
      return value["id"];
    },
    delete(value) {
      return this.$axios.delete(`/purchase_orders/${this.getModelKey(value)}`);
    },
    fetchModels(page = 1) {
      const highlightedPurchaseOrders = this.$route.params.highlight || [];
      return this.$axios
          .get("/purchase_orders", {
            params: {
              page: page,
              per_page: this.perPage,
              search: this.search,
              withAggregate: true,
              with: [
                "creator",
                "customer",
                "product",
                "paymentables",
                "ticket",
                "farmer",
                "farm",
                "odoo_purchase_order.odoo_purchase_order_lines"
              ].join(","),
              sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
              ...this.$route.params,
              ...this.filterParams
            }
          })
          .then(response => {
            const {
              data: {data, meta, aggregate}
            } = response;

            const models = data.map(datum => {
              return {
                ...datum,
                ordered_at: datum.ordered_at || datum.estimated_harvest_date,
                ...this.modelPolicy(datum),
                highlighted: highlightedPurchaseOrders.includes(datum.id.toString())
              };
            });
            const lastHighlightedIndex = [...models].filter(model => model.highlighted).length - 1;
            if (lastHighlightedIndex !== -1) {
              models[lastHighlightedIndex].highlight_separator = true;
            }

            this.$set(this, 'models', models)
            this.page = Number(meta.current_page);
            this.perPage = Number(meta.per_page);
            this.from = Number(meta.from);
            this.total = Number(meta.total);
            this.quantity_total = Number(aggregate?.quantity_total);
            this.price_total = Number(aggregate?.price_total);
            this.stats = [
              {
                title: this.lodash.startCase(this.$t("purchase_orders.count")),
                value: this.$numeral(meta.total).format("0,0.[00]"),
                valueTitle: this.$numeral(meta.total).format("0,0.[00]"),
                wrapperClass: "col-12 col-md-6 col-xl-4",
                component: StatusWidget
              },
              {
                title: this.lodash.startCase(this.$t("purchase_orders.total_biomassa")),
                value: `${this.$numeral(meta.total_quantity / 1000).format("0,0.[00]")}`,
                valueTitle: `${this.$numeral(meta.total_quantity / 1000).format("0,0.[00]")}`,
                wrapperClass: "col-12 col-md-6 col-xl-4",
                component: StatusTonWidget
              },
              {
                title: this.lodash.startCase(this.$t("purchase_orders.total_price")),
                value: this.$numeral(meta.total_price).format("0,0.[00]"),
                valueTitle: this.$numeral(meta.total_price).format("0,0.[00]"),
                wrapperClass: "col-12 col-md-12 col-xl-4",
                component: StatusDateWidget
              }
            ];
            return response;
          })
          .catch(error => {
            this.failedAlert(error)
          });
    },
    failedAlert(error) {
      return Swal.fire({
        title: this.$t("Failed") + "!",
        text: (error.response && (error.response.data || {}).message) || error.message,
        type: "danger",
        confirmButtonClass: "btn btn-danger btn-fill",
        buttonsStyling: false
      });
    },
    hasAllowedAction(model, actions) {
      return hasAllowedActionHelper(model, actions);
    },
    modelPolicy(model) {
      return {
        _denyShow: false,
        _denyEdit: !this.hasAllowedAction(model, ["edit", "update"]),
        _denyDelete: !this.hasAllowedAction(model, ["delete", "destroy"]),
      }
    },
    adminModelPolicy() {
      return {
        _denyShow: false,
        _denyEdit: false,
        _denyDelete: false,
      }
    },
    fieldAssistantModelPolicy(model) {
      let isDownPayment = model.type === "down_payment";

      if (isDownPayment) {
        return {
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: false,
        }
      }

      let isOwner = model?.creator?.email === this.$auth?.user()?.email;

      return {
        _denyShow: false,
        _denyEdit: false,
        _denyDelete: !isOwner,
      }
    },
    handleSyncToOdoo(order) {
      this.busy = true
      return this.$axios.post(`/purchase_orders/${order.id}/sync_to_odoo`)
          .then(() => {
            return Swal.fire({
              icon: "success",
              title: this.$t("odoo_sync_messages.add_{order}_to_queue_title", {order: this.lodash.startCase(this.$t(`${this.resourceRoute}.singular`))}),
              text: this.$t("odoo_sync_messages.add_{id}_{order}_to_queue_successfully", {
                id: order.id,
                order: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.singular`)),
              }),
              type: 'success',
              showConfirmButton: true,
              confirmButtonText: this.$t("Understood"),
            })
          })
          .catch(() => {
            return Swal.fire({
              title: `${this.$t('odoo_sync_messages.failed_title')}!`,
              text: this.$t('odoo_sync_messages.failed_message'),
              type: 'danger',
              confirmButtonClass: 'btn btn-primary btn-fill',
              confirmButtonText: this.$t('Retry'),
              showCancelButton: true,
              cancelButtonClass: 'btn btn-danger btn-fill ms-2',
              cancelButtonText: this.$t('Cancel'),
              buttonsStyling: false
            }).then(result => {
              if (result.isConfirmed) {
                return this.handleSyncToOdoo(order)
              }
            })
          }).finally(() => {
            this.busy = false
            this.$router.go(0)
          })
    }
  },
  mounted() {
    window.addEventListener("click", function () {
      const highlightedRows = document.querySelectorAll(".highlighted-row");
      highlightedRows.forEach(el => {
        el.classList.remove("highlighted-separator", "highlighted-row");
      });
    });
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .page-content {
    background: #eef3f7 !important;
    font-family: Lato;
    color: #161b4d;
  }

  .text-right {
    text-align: right;
  }
}
</style>
<style>
body {
  max-width: 100vw !important;
  overflow-x: hidden !important;
}

.highlighted-row {
  background: #ddefff;
}

.highlighted-separator {
  border-bottom: 1px solid #1b77df;
  position: relative;

  .separator-badge {
    & ::before {
      content: "baru ditambahkan";
      position: absolute;
      bottom: -10px;
      border-radius: 4px;
      background: #1b77df;
      color: white;
      text-align: center;
      padding: 2px 5px;
      left: 0;
      font-size: 10px;
    }
  }
}

.highlighted-separator-badge {
  position: absolute;
  top: 100px;
  left: 100px;
  background: blue;
}
</style>
